<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar :color="options.bgColor" flat>
        <v-toolbar-title v-bind:class="options.colorClass" class="text-body-2 font-weight-bold">
          {{ title }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text
        v-show="!!message"
        class="pa-4 black--text"
        v-html="message"
      ></v-card-text>
      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>
        <v-btn
          v-if="!options.noconfirm"
          color="grey"
          text
          class="body-2 font-weight-bold conf-button"
          @click="cancel"
        >{{ options.cancelText }}</v-btn
        >
        <v-btn
          color="primary"
          class="body-2 font-weight-bold conf-button"
          outlined
          @click="agree"
        >{{ options.confirmText }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    options: {
      bgColor: "#fff",
      colorClass: "title-dark",
      type: "info",
      confirmText: "OK",
      cancelText: "Cancel",
      width: 400,
      zIndex: 200,
      noconfirm: false,
    }
  }),
  methods: {
    open(title, message, options) {
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      this.setColors();
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    setColors() {
      if (this.options.type === 'danger') {
        this.options.colorClass = 'title-light';
        this.options.bgColor = '#F44336';
      }

      if (this.options.type === 'success') {
        this.options.colorClass = 'title-light';
        this.options.bgColor = '#4CAF50';
      }
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
}
</script>

<style lang="scss" scoped>
.title-light {
  color: #FFF;
}

.title-dark {
  color: #333;
}

.v-card__text {
  padding-top: 15px !important;
}

.conf-button {
  margin-left: 10px;
}
</style>
